import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { useCreateClientForm, useTemplates } from '../../api/queries';
import { errorMessage } from '../../lib/api';

export function CreateLinkForm({
  defaultTemplateId,
  onCancel,
}: {
  defaultTemplateId?: string;
  onCancel: () => void;
}) {
  const { data: templates } = useTemplates();
  const create = useCreateClientForm();
  const navigate = useNavigate();
  const [templateId, setTemplateId] = useState(defaultTemplateId ?? '');
  const [clientName, setClientName] = useState('');
  const [clientEmail, setClientEmail] = useState('');

  const selected = templateId || templates?.[0]?.id || '';

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    create.mutate(
      { templateId: selected, clientName, clientEmail: clientEmail || undefined },
      { onSuccess: (cf) => navigate(`/admin/links/${cf.id}?created=1`) },
    );
  }

  return (
    <form className="card create-link" onSubmit={handleSubmit}>
      <h2>New client link</h2>
      <p className="muted small">
        Each client gets a private link named after them, e.g.{' '}
        <code>/f/acme-bakery-7hq2mx9kpa</code>.
      </p>
      <div className="field-grid">
        <label className="field">
          <span>Client name *</span>
          <input
            className="input"
            required
            autoFocus
            maxLength={200}
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
            placeholder="e.g. Acme Bakery"
          />
        </label>
        <label className="field">
          <span>Client email (optional)</span>
          <input
            className="input"
            type="email"
            value={clientEmail}
            onChange={(e) => setClientEmail(e.target.value)}
            placeholder="owner@example.com"
          />
        </label>
        <label className="field span-2">
          <span>Template *</span>
          <select
            className="select"
            required
            value={selected}
            onChange={(e) => setTemplateId(e.target.value)}
          >
            {templates?.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name} ({t.questionCount} questions)
              </option>
            ))}
          </select>
        </label>
      </div>
      {create.error && <div className="alert alert-error">{errorMessage(create.error)}</div>}
      <div className="row">
        <button className="btn btn-primary" disabled={create.isPending || !selected}>
          {create.isPending ? 'Creating…' : 'Create link'}
        </button>
        <button type="button" className="btn btn-ghost" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
}
